// extracted by mini-css-extract-plugin
export var chevron = "_2m-2";
export var chevronCollapsed = "_2m-3";
export var collapsibleHeader = "_2m-1";
export var container = "_2m-0";